<template><svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_7048_71368)">
<path d="M0 15.9705H4.00476V11.9541H7.9837V7.91064H12.0254V3.94236H16.0397V0H22V2.01145H18.0377V5.9688H14.0188V9.98184H10.0081V13.974H5.98087V18H0V15.9705Z" fill="#1A1A1A"/>
</g>
<defs>
<clipPath id="clip0_7048_71368">
<rect width="22" height="18" fill="white"/>
</clipPath>
</defs>
</svg>
</template>